import { ITaskTemplateVersion } from '@core/entities/task/TaskTemplateVersion'
import {
  RequestTypes,
  taskTemplateKeys,
} from '@core/react-query/features/tasks/templates'
import { RequestErrorType } from '@core/utils/api-axios-instance'
import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query'

export const useUpdateTaskTemplateSteps = (
  options?: UseMutationOptions<
    ITaskTemplateVersion,
    RequestErrorType,
    RequestTypes['updateTaskTemplateSteps']
  >,
) => {
  const queryClient = useQueryClient()

  return useMutation({
    ...taskTemplateKeys.updateTaskTemplateSteps,
    ...options,
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: taskTemplateKeys.getTaskTemplate({
          templateId: variables.templateId,
        }).queryKey,
      })
      queryClient.invalidateQueries({
        queryKey: taskTemplateKeys.getTaskTemplateVersion({
          templateId: variables.templateId,
          versionId: variables.versionId,
        }).queryKey,
      })
    },
  })
}
